import { render, staticRenderFns } from "./TeamDecorationBox.vue?vue&type=template&id=61e59eda&scoped=true&"
import script from "./TeamDecorationBox.vue?vue&type=script&lang=js&"
export * from "./TeamDecorationBox.vue?vue&type=script&lang=js&"
import style0 from "./TeamDecorationBox.vue?vue&type=style&index=0&id=61e59eda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e59eda",
  null
  
)

export default component.exports